import { SectionTitle } from "../_shared/section-title";
import { PageShell, Stack } from "../_shared/page-shell";
import { Avatar } from "../_shared/avatar";
import { IconChevronRight, IconMessage } from "../_shared/icons";
import { navigate } from "../_shared/router";
import { conversations } from "../_data/mock";

export function MessagesPage() {
  return (
    <>
      <SectionTitle title="Messages" showBack={false} />
      <PageShell>
        <Stack>
          <button
            type="button"
            onClick={() => navigate("contact")}
            className="flex items-center gap-3 rounded-2xl bg-[var(--surface-1)] p-4 text-left shadow-[0_1px_3px_rgba(15,23,42,0.04)] ring-1 ring-[var(--border-1)] transition hover:bg-[var(--surface-2)] active:scale-[0.99]"
          >
            <span className="inline-flex size-11 items-center justify-center rounded-xl bg-[var(--sf-primary-100)] text-[var(--sf-primary)]">
              <IconMessage width={20} height={20} />
            </span>
            <div className="min-w-0 flex-1">
              <p className="text-[14.5px] font-semibold text-[var(--text-1)]">
                Contacter le cabinet
              </p>
              <p className="mt-0.5 text-[12.5px] text-[var(--text-2)]">
                Photo d'urgence, prévenir d'une absence, annuler un RDV…
              </p>
            </div>
            <IconChevronRight
              width={16}
              height={16}
              className="shrink-0 text-[var(--text-3)]"
            />
          </button>

          <ul className="divide-y divide-[var(--border-1)] overflow-hidden rounded-2xl bg-[var(--surface-1)] shadow-[0_1px_2px_rgba(15,23,42,0.06)] ring-1 ring-[var(--border-1)]">
            {conversations.map((c) => (
              <li key={c.id}>
                <button
                  type="button"
                  onClick={() => navigate("chat")}
                  className="flex w-full items-center gap-3 px-4 py-3 text-left transition hover:bg-[var(--surface-2)] active:bg-[var(--surface-2)]"
                >
                  <Avatar
                    initials={c.withName.slice(0, 2)}
                    photoUrl={c.photoUrl}
                    alt={c.withName}
                    tone="gray"
                    size="lg"
                  />
                  <div className="min-w-0 flex-1">
                    <div className="flex items-baseline justify-between gap-2">
                      <p className="truncate text-[14.5px] font-semibold text-[var(--text-1)]">
                        {c.withName}
                      </p>
                      <span className="shrink-0 text-[11px] text-[var(--text-2)]">
                        {c.lastMessageAt}
                      </span>
                    </div>
                    <p className="mt-0.5 truncate text-[13px] text-[var(--text-2)]">
                      {c.preview}
                    </p>
                  </div>
                  {c.unread > 0 ? (
                    <span className="inline-flex size-5 shrink-0 items-center justify-center rounded-full bg-[var(--sf-primary)] text-[10px] font-bold text-white">
                      {c.unread}
                    </span>
                  ) : null}
                </button>
              </li>
            ))}
          </ul>
        </Stack>
      </PageShell>
    </>
  );
}
